import styled from "styled-components";

export const WidgetFrameTitleInformationTooltipLastImport = styled.div`
    color: ${({ theme }) => theme.color.grayDairyDarker};

    text-align: right;
`;
